// extracted by mini-css-extract-plugin
export var active = "_9y-a";
export var activeIndicator = "_9y-9";
export var disabled = "_9y-b";
export var fullWidth = "_9y-2";
export var lg = "_9y-7";
export var md = "_9y-6";
export var redoButtonTabGroup = "_9y-0";
export var sm = "_9y-5";
export var tabButton = "_9y-4";
export var tabButtonsContainer = "_9y-1";
export var themeDestructive = "_9y-d";
export var themeNormal = "_9y-c";
export var themeSuccess = "_9y-e";
export var xl = "_9y-8";
export var xs = "_9y-3";